module.exports = __webpack_public_path__ + "img/mastercard.84ebf12c.svg";